// Books data - imported from centralized configuration
import booksConfig from '@/../../../config/books.config.json';

export interface BookData {
  volume?: number;
  title: {
    it: string;
    en: string;
  };
  subtitle?: {
    it: string;
    en: string;
  };
  description: {
    it: string;
    en: string;
  };
  amazonLink: string;
  coverImage?: string;
  asin?: string;
  series?: string;
}

// Map config data to match expected format
export const booksData: BookData[] = booksConfig.books.map(book => ({
  volume: book.volume,
  title: book.title,
  subtitle: book.subtitle,
  description: book.description,
  amazonLink: book.url,
  coverImage: book.coverImage,
  asin: book.asin,
  series: book.series
}));
